var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Api, CV_TRANSLATE_URL } from "@services";
export const translateSingleRevision = (email, revisionName, from, to) => __awaiter(void 0, void 0, void 0, function* () {
    const { data: response } = yield Api.post(`${CV_TRANSLATE_URL}?userId=${email}&revisionName=${revisionName}&from=${from}&to=${to}`);
    return response;
});
export const translateCustomSectionsHeaders = (email, revisionName, from, to) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield translateSingleRevision(email, revisionName, from, to);
    return response.customSections;
});
